var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatisticDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.78033 0.96967C1.48744 0.676777 1.01256 0.676777 0.71967 0.96967C0.426777 1.26256 0.426777 1.73744 0.71967 2.03033L4.46967 5.78033C4.76256 6.07322 5.23744 6.07322 5.53033 5.78033L9.28033 2.03033C9.57322 1.73744 9.57322 1.26256 9.28033 0.96967C8.98744 0.676777 8.51256 0.676777 8.21967 0.96967L5 4.18934L1.78033 0.96967ZM1.78033 6.21967C1.48744 5.92678 1.01256 5.92678 0.71967 6.21967C0.426777 6.51256 0.426777 6.98744 0.71967 7.28033L4.46967 11.0303C4.76256 11.3232 5.23744 11.3232 5.53033 11.0303L9.28033 7.28033C9.57322 6.98744 9.57322 6.51256 9.28033 6.21967C8.98744 5.92678 8.51256 5.92678 8.21967 6.21967L5 9.43934L1.78033 6.21967Z",
    fill: "#FF3434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticDown);
export default __webpack_public_path__ + "static/media/statistic_down.ff22de5c8d4eab612b69c1a83264dbc9.svg";
export { ForwardRef as ReactComponent };